import React from 'react';
import PropTypes from 'prop-types';
import {
  StyledModal,
  StyledModalHeader,
} from '../../../../../../common/form/FormElements.jsx';
import { NewsSignature } from '../../../../../../../utils/helpers/UtilityComponents.jsx';
import { Spinner } from '../../../../../../common/index.jsx';
import HtmlContentWithAntdImages from '../../../../../../common/Image/HtmlContentWithAntdImages.jsx';

const NewsModal = ({
  visible,
  toggleModal,
  title,
  presentationImage,
  content,
  dateOfCreate,
  creatorName,
  isLoading,
}) => {
  return (
    <>
      {visible && (
        <StyledModal
          open={visible}
          width="100%"
          className="hp-news-modal-container news-modal-wrapper add-icons-to-file-anchors"
          style={{ maxWidth: '900px' }}
          onCancel={() => toggleModal()}
          footer={null}
        >
          {isLoading ? (
            <div
              style={{
                height: '100px',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <Spinner />
            </div>
          ) : (
            <>
              <StyledModalHeader>
                <a className={`second-title title`} href="#">
                  {title}
                </a>
              </StyledModalHeader>
              <div style={{ padding: '10px' }}>
                {presentationImage && (
                  <div
                    className="foto-wrapper"
                    style={{ float: 'left', marginRight: '7px' }}
                  >
                    <img
                      src={'/storage/presentation_images/' + presentationImage}
                      alt={title}
                      title={title}
                    />
                  </div>
                )}

                <HtmlContentWithAntdImages content={content} />

                <NewsSignature
                  nameOfCreator={creatorName}
                  dateOfCreation={dateOfCreate}
                />
              </div>
            </>
          )}
        </StyledModal>
      )}
    </>
  );
};

NewsModal.propTypes = {
  visible: PropTypes.bool,
  isLoading: PropTypes.bool,
  toggleModal: PropTypes.func,
  content: PropTypes.string,
  creatorName: PropTypes.string,
  dateOfCreate: PropTypes.any,
  title: PropTypes.string,
  mail: PropTypes.string,
};

export default NewsModal;
